import { createRoot } from "react-dom/client";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import utc from "dayjs/plugin/utc";
import { ThemeProvider, App as NxApp } from "@nexgensis/core";
import "@nexgensis/core/dist/core.css"; // core styles first, project styles after
import "react-toastify/dist/ReactToastify.css";
import "simplebar/src/simplebar.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./index.css";

// third-party
import { Provider as ReduxProvider } from "react-redux";

// apex-chart

// project import
import App from "./App";
import { store } from "@/store";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";
import "@/i18n";

// Needed by @nexgensis/core DatePicker / TimePicker
[weekday, localeData, weekOfYear, weekYear, advancedFormat, customParseFormat,
 isBetween, isSameOrBefore, isSameOrAfter, utc].forEach((plugin) => dayjs.extend(plugin));

// ==============================|| MAIN - REACT DOM RENDER  ||============================== //

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  // <StrictMode>
  <ReduxProvider store={store}>
    <ThemeProvider defaultTheme="nexgensis" defaultMode="light" persistTheme>
      <NxApp>
        <ToastContainer />
        <App />
      </NxApp>
    </ThemeProvider>
  </ReduxProvider>
  // </StrictMode>
);
reportWebVitals();
